import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import camelCase from 'lodash/camelCase';
import Select from 'components/ui/SelectField';
import Form from 'components/ui/Form';
import Col from 'components/ui/Col';

const classifications = ['General Maintenance', 'Capital Projects', 'Replacement'];

const Classification = ({ setFieldValue, value, errors, touched, disabled }) => {
  return (
    <Col span={12}>
      <Form.Item
        label={`${getTranslatedString('landlordPortal.editMaintenanceTicketForm.classification')}`}
        validateStatus={touched.classification && errors.classification ? 'error' : null}
        help={touched.classification && errors.classification}
      >
        <Select
          placeholder={getTranslatedString('landlordPortal.maintenance.placeHolder.select')}
          size="large"
          value={value}
          disabled={disabled}
          onChange={(value) => {
            setFieldValue('classification', value);
          }}
        >
          {classifications.map((classification, i) => (
            <Select.Option value={classification} key={`${classification}_${i}`}>
              {getTranslatedString(
                `landlordPortal.editMaintenanceTicketForm.${camelCase(classification)}`
              )}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Col>
  );
};

export default Classification;
